import _ from 'lodash'
import * as location from '@paypalcorp/instance-location'

function validateAction(req, res, next) {
  const urlValues = removeTrailingSlashes(req.url).split('/')
  const action = _.last(urlValues)
  const restrictedActionForAdhocUser = [
    'shares',
    'sharedByMe',
    'sharedWithMe',
    'track',
  ]

  if (
    req.params.userType === 'adhoc' &&
    restrictedActionForAdhocUser.indexOf(action) !== -1
  ) {
    sendErrorResponse(req, res, 'error.permission.denied', 500)
  } else {
    return next()
  }
  return false
}

function validateUserType(req, res, next) {
  if (req.user.hasOwnProperty('accType')) {
    if (req.user.accType === req.params.userType) {
      return next()
    }
    sendErrorResponse(req, res, 'error.invalid.usertype', 400)
  } else {
    sendErrorResponse(req, res, 'error.unauthorised.user', 401)
  }
  return false
}

function isAuthenticated(req, res, next) {
  if (req.user !== undefined) {
    if (req.user.username === req.params.username) {
      return next()
    }
    sendErrorResponse(req, res, 'error.unauthorised.user', 401)
  } else {
    sendErrorResponse(req, res, 'error.authentication.failure', 401)
  }
  return false
}

function validateFilters(req, res, next) {
  const appliedFilters = Object.keys(req.body)
  const restrictedFiltersForAdhocUser = ['sharedWith', 'isShared']

  if (
    req.params.userType === 'adhoc' &&
    _.intersection(appliedFilters, restrictedFiltersForAdhocUser).length > 0
  ) {
    sendErrorResponse(req, res, 'error.permission.denied', 500)
  } else {
    return next()
  }
  return false
}

function sendErrorResponse(req, res, message, statuscode) {
  if (statuscode === 401) {
    req.logout()
  }
  res.status(statuscode).end(
    JSON.stringify({
      status: statuscode,
      errorMessage: message,
      clientError: true,
    }),
  )
}

function validateDestination(req, res, next) {
  const destination = req.body.destinationFile

  if (destination) {
    const destinationPaths = removeTrailingSlashes(destination)
      .split('/')
      .map((i) => i.trim())
    const isNotAValidDestination =
      destinationPaths.includes('.') || destinationPaths.includes('..')

    if (isNotAValidDestination) {
      res.status(400).end(
        JSON.stringify({
          status: 400,
          errorMessage: 'error.invalid.destination.path',
          clientError: true,
        }),
      )
      return false
    }
    if (isNotProperFileName(destination)) {
      res.status(400).end(
        JSON.stringify({
          status: 400,
          errorMessage: 'alert.special.chars.not.allowed',
          clientError: true,
        }),
      )
      return false
    }
  }
  return next()
}

function isNotProperFileName(folderName) {
  const checkSpecialChar = /[#%\[\]:\\?]/
  /* Punctuation mark(:) is not allowed by file system.
      The characters # % \ ? [ ] are browser unsafe characters
      */
  return checkSpecialChar.test(folderName)
}

function updateShareURLAndParams(req) {
  const shareTypeFromURL = _.last(removeTrailingSlashes(req.url).split('/'))
  let shareType = ''
  if (shareTypeFromURL === 'sharedByMe') {
    shareType = 'sharedBy'
  } else if (shareTypeFromURL === 'sharedWithMe') {
    shareType = 'sharedWith'
  }
  req.url = `/${req.params.userType}/${req.params.username}/path/${req.params[0]}/action/search`

  req.body[shareType] = req.params.username
  return req
}

function removePrefixFromHost(host) {
  return host.replace(/^(www\.)/, '')
}

function removeTrailingSlashes(string) {
  return string.replace(/^\/+|\/+$/g, '')
}

function validateEmailId(mailId) {
  const regxToValidateMailId = /^[a-zA-Z0-9._+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/
  return regxToValidateMailId.test(mailId)
}

function validateCustomMessage(message) {
  const linkRegex = /\b(?:(?:https?|ftp|http):\/\/|www\.)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]/g
  const htmlRegex = /<\/?[^>]+(>|$)/g

  const isLinkPresent = linkRegex.test(message)
  const isTagsPresent = htmlRegex.test(message)

  if (isLinkPresent) {
    return 'share.link.not.allowed.alert'
  }
  if (isTagsPresent) {
    return 'share.html.tag.not.allowed.alert'
  }
  return ''
}

function getPayPalUserType() {
  if (location.getGeoLower() === 'pp_cn') {
    return 'gopayinc'
  }
  return 'paypalcorp'
}

function validateRole(userRole, requiredRolesList) {
  if (typeof userRole === 'string') {
    return _.includes(requiredRolesList, userRole)
  }
  return _.intersection(userRole, requiredRolesList).length > 0
}

export {
  validateAction,
  validateUserType,
  isAuthenticated,
  validateFilters,
  sendErrorResponse,
  validateDestination,
  isNotProperFileName,
  updateShareURLAndParams,
  removePrefixFromHost,
  removeTrailingSlashes,
  validateEmailId,
  validateCustomMessage,
  getPayPalUserType,
  validateRole,
}
